import {config} from '@config'
import {ComponentGenerator, ComponentMap, createStore, StoreProvider} from 'lowkey-component'

import {Debug} from '@helpers/Debug'
import {Time} from '@helpers/Time'
import {domLoaded, getPreloadUrls} from '@helpers/dom'
import {sleep} from '@lib/utils'
import {Preloader} from '@services//loader/Preloader'
import {createApplicationState} from '@services/ApplicationState'
import {MediaQuery} from '@services/MediaQuery'
import {OrientationService} from '@services/OrientationService'
import {Navigation} from '@services/navigation/Navigation'
import {rootReducer} from '@store/rootReducer'


Time.create().start('prepare')
Debug.init()

export const createApplicationInitializer = (componentMap: ComponentMap) => {
  let loadedCount = 0
  const preloader = Preloader.create()
  const generator = new ComponentGenerator(componentMap)
  const navigation = Navigation.create({generator, preloader})
  const appState = createApplicationState()
  const mediaQuery = MediaQuery.create(config.mediaQueryString)
  const orientationService = OrientationService.create()

  const {getState, dispatch, subscribe} = createStore(rootReducer)

  const storeProvider = StoreProvider.create()
  storeProvider.setContext({dispatch, getState, subscribe})

  return {
    init: async () => {
      // state の初期化
      mediaQuery.mode && appState.updateMediaQueryScreenMode(mediaQuery.mode)
      orientationService.orientation &&
      appState.updateOrientation(orientationService.orientation)

      // DOMのロード待ち
      await domLoaded()

      mediaQuery.onChange.connect((mode) => {
        appState.updateMediaQueryScreenMode(mode)
      })

      orientationService.onChange.connect((orientation) => {
        appState.updateOrientation(orientation)
      })

      generator.initialize()

      const urls = getPreloadUrls()
      if (urls.length > 0) {
        preloader.onLoad.connect(() => {
          loadedCount++
          appState.updateSiteIndicatorPercent(loadedCount / urls.length)
        })
        await preloader.load(urls)
        // loadと順番
      } else {
        appState.updateSiteIndicatorPercent(1)
      }

      generator.mount()

      navigation.start(config.navigationSwitchSelector)

      // splash screenを最低○秒見せたいので
      await sleep(
        config.initialSiteIndicatorDuration -
        Time.create().getDuration('prepare'),
      )
      appState.updateSiteIndicatorStatus('hide')
    },
  }
}
